module.exports = __webpack_public_path__ + "static/img/zijian1.36d92446.png";